import { DOCUMENT } from '@angular/common';
import { DestroyRef, Directive, inject } from '@angular/core';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';

@Directive({
  selector: 'input[bsDatepicker][readonly]',
  standalone: true
})
export class BsDatepickerCloseOnClearDirective {
  private readonly datepicker = inject(BsDatepickerDirective, { self: true });
  private readonly document = inject(DOCUMENT);

  private readonly onDocumentClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement;
    if (!this.datepicker.isOpen || !target?.closest('.btn-clear-wrapper')) {
      return;
    }
    // clicking Clear when there's no date leaves the picker's store value unchanged, so it never
    // emits bsValueChange and never auto-closes; defer so Clear's own click handler runs first.
    setTimeout(() => this.datepicker.hide());
  };

  constructor() {
    this.document.addEventListener('click', this.onDocumentClick, true);
    inject(DestroyRef).onDestroy(() => this.document.removeEventListener('click', this.onDocumentClick, true));
  }
}
